import apiFetch from '../apiFetch'

export default function (token, maritalStatus) {
  return apiFetch({ endPoint: `MaritalStatus/${maritalStatus.maritalStatusId}`, method: 'DELETE', body: null, token: token })
}
